import React from 'react';
import { List, ListItem } from '@mui/material';
import { styled } from '@mui/material/styles';

const ListWrapper = styled(List)(({ theme }) => ({
    width: '100%',
    padding: 0,
    // overflow is handled by the parent container in UniversalKnowledgeBasePanel
}));

const StyledListItem = styled(ListItem)(({ theme }) => ({
    borderBottom: '1px solid #f1f5f9',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    marginBottom: '8px',
    border: '1px solid #e2e8f0',
    padding: '12px 16px',
    '&:hover': {
        backgroundColor: '#f8fafc',
    },
}));

export const UniversalListItem = ({ children, secondaryAction, ...props }) => (
    <StyledListItem secondaryAction={secondaryAction} {...props}>
        {children}
    </StyledListItem>
);

const UniversalList = ({ items, renderItem, emptyState }) => {
    if (!items || items.length === 0) {
        return emptyState || null;
    }

    return (
        <ListWrapper>
            {items.map((item, index) => renderItem(item, index))}
        </ListWrapper>
    );
};

export default UniversalList;
